import { gql } from '@apollo/client';

const HOLTER_RR_HEATMAP_COUNT_QUERY = gql`
  query holterRrHeatMapCount($filter: HolterRrCellsFilter!, $limit: Int) {
    holterRrHeatMapCount(filter: $filter, limit: $limit) {
      isSuccess
      message
      rrHeatMapType
      rrHeatMap {
        id
        row
        col
        reviewed
        total
        templates {
          id
          total
          reviewed
        }
      }
    }
  }
`;

export default HOLTER_RR_HEATMAP_COUNT_QUERY;
